module.exports = __webpack_public_path__ + "static/henesis_ethereum_mobile_bg@2x-31dcd0c72a58838854aa3988ad21de8b.png";